import _ from 'lodash';
import * as addressAPI from '../services/business';

export default {
  namespace: 'address',

  state: {
    visibleModal: false,
    modalType: '',
    data: null,
    provinces: null,
    districts: null,
    wards: null,
    provincesFilter: null,
  },

  effects: {
    *changeVisibleModal({ payload }, { put }) {
      yield put({
        type: 'saveVisibleModal',
        payload,
      });
    },

    *setDataAddress({ payload }, { put }) {
      yield put({
        type: 'saveDataAddress',
        payload,
      });
    },

    *getProvinces({ payload }, { call, put }) {
      const response = yield call(addressAPI.getProvinces, payload);
      if (response.success) {
        const items = _.get(response, 'result.items', response.result);
        yield put({
          type: 'saveProvinces',
          payload: {
            items,
          },
        });
        return items;
      }
      return [];
    },

    *getDistricts({ payload }, { call, put }) {
      const response = yield call(addressAPI.getDistricts, payload);
      if (response.success) {
        yield put({
          type: 'saveDistricts',
          payload: {
            items: response.result.items,
          },
        });
      }
    },

    *getLocationByAddress({ payload }, { call }) {
      const response = yield call(addressAPI.getLocationByAddress, payload);
      if (response.success) {
        return response.result;
      }
      return {};
    },

    *getWards({ payload }, { call, put }) {
      const response = yield call(addressAPI.getWards, payload);
      if (response.success) {
        yield put({
          type: 'saveWards',
          payload: {
            items: response.result.items,
          },
        });
      }
    },

    *resetAddress(_action, { put }) {
      yield put({
        type: 'saveDataAddress',
        payload: {
          address: null,
        },
      });
    },
  },

  reducers: {
    saveVisibleModal(state, { payload }) {
      return {
        ...state,
        visibleModal: payload.status,
      };
    },

    saveDataAddress(state, { payload }) {
      return {
        ...state,
        data: payload.address,
      };
    },

    saveProvinces(state, { payload }) {
      return {
        ...state,
        provinces: payload.items,
      };
    },

    saveDistricts(state, { payload }) {
      return {
        ...state,
        districts: payload.items,
      };
    },

    saveWards(state, { payload }) {
      return {
        ...state,
        wards: payload.items,
      };
    },

    resetData() {
      return {
        data: null,
        provinces: null,
        districts: null,
        wards: null,
        provincesFilter: null,
      };
    },

    saveProvincesFilter(state, { payload }) {
      return {
        ...state,
        provincesFilter: payload.items,
      };
    },
  },
};
